/**
 * Nove Wholesale page — interactions (vanilla JS, no deps)
 */
(function () {
  'use strict';

  /* ---- Accordion ---- */
  document.querySelectorAll('.ws-accordion-trigger').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (trigger.getAttribute('aria-expanded') === 'true' && panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (!panel) return;
      panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---- Yes / No toggle ---- */
  document.querySelectorAll('.ws-toggle').forEach(function (group) {
    group.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        group.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', 'true');
        var input = document.getElementById('ws-customize-input');
        if (input) {
          var val = b.getAttribute('data-toggle');
          input.value = val === 'yes' ? 'Yes' : 'No';
        }
      });
    });
  });

  /* ---- Quantity-based customization check ---- */
  var qtyInput = document.getElementById('ws-qty');
  var customizeInput = document.getElementById('ws-customize-input');
  var yesButton = document.querySelector('.ws-toggle button[data-toggle="yes"]');
  var noButton = document.querySelector('.ws-toggle button[data-toggle="no"]');

  function updateCustomizationState() {
    if (!qtyInput) return;
    var qtyValue = parseInt(qtyInput.value, 10);
    if (isNaN(qtyValue) || qtyValue < 500) {
      if (yesButton) {
        yesButton.disabled = true;
        if (yesButton.getAttribute('aria-pressed') === 'true') {
          yesButton.setAttribute('aria-pressed', 'false');
          if (noButton) {
            noButton.setAttribute('aria-pressed', 'true');
          }
          if (customizeInput) {
            customizeInput.value = 'No';
          }
        }
      }
    } else {
      if (yesButton) {
        yesButton.disabled = false;
      }
    }
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', updateCustomizationState);
    qtyInput.addEventListener('change', updateCustomizationState);
    updateCustomizationState();
  }

  /* ---- Tier "Add N to Cart" buttons ---- */
  document.querySelectorAll('.ws-tier .btn-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      if (!variantId) {
        alert('Adding ' + qty + ' units to cart. (Set variant ID in theme editor to enable.)');
        return;
      }

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw new Error(err.description || err.message || 'Could not add to cart.');
            });
          }
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          var msg = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
          alert(msg);
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });

  /* ---- Bulk Quote Form AJAX Submission ---- */
  var quoteForm = document.getElementById('bulk-quote-form');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtn = quoteForm.querySelector('.ws-quote-submit');
      if (!submitBtn) return;
      var originalHtml = submitBtn.innerHTML;

      // Reset error state and set loading state
      quoteForm.classList.remove('ws-form-failed');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      // Check if Shopify has injected hCaptcha
      var hcaptchaDiv = quoteForm.querySelector('.h-captcha');
      var iframe = hcaptchaDiv ? hcaptchaDiv.querySelector('iframe') : null;
      var widgetId = iframe ? (iframe.dataset.hcaptchaWidgetId || iframe.getAttribute('data-hcaptcha-widget-id')) : null;

      function submitForm(captchaToken) {
        var formData = new FormData(quoteForm);
        if (captchaToken) {
          formData.set('h-captcha-response', captchaToken);
        }

        // Strip the hash fragment from the action URL if present
        var actionUrl = (quoteForm.getAttribute('action') || '/contact').split('#')[0];
        
        fetch(actionUrl, {
          method: 'POST',
          body: formData
        })
        .then(function (res) {
          if (res.ok) {
            quoteForm.classList.add('ws-form-submitted');
          } else {
            throw new Error('Form submission failed.');
          }
        })
        .catch(function (err) {
          console.error(err);
          quoteForm.classList.add('ws-form-failed');
          var errorDesc = quoteForm.querySelector('.ws-error-description');
          if (errorDesc) {
            errorDesc.textContent = 'There was a problem submitting your request. Please try again.';
          }
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHtml;
        });
      }

      if (window.hcaptcha && widgetId) {
        // Execute invisible hCaptcha
        hcaptcha.execute(widgetId);

        // Poll the iframe attribute for the verification token
        var start = Date.now();
        var interval = setInterval(function () {
          var token = iframe.dataset.hcaptchaResponse || iframe.getAttribute('data-hcaptcha-response');
          if (token) {
            clearInterval(interval);
            submitForm(token);
          } else if (Date.now() - start > 10000) { // 10 second timeout
            clearInterval(interval);
            console.error('hCaptcha token did not appear in time');
            quoteForm.classList.add('ws-form-failed');
            var errorDesc = quoteForm.querySelector('.ws-error-description');
            if (errorDesc) {
              errorDesc.textContent = 'Captcha verification timed out. Please try again.';
            }
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHtml;
          }
        }, 100);
      } else {
        // Fallback if hCaptcha is not loaded or disabled
        submitForm();
      }
    });
  }

})();
